import React from 'react'

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  }
}

const CenteredContent = ({ children }) =>
  <div style={styles.root}>
    { children }
  </div>

export default CenteredContent



// WEBPACK FOOTER //
// ./src/components/standard/CenteredContent.js